import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PageTitle from "../../components/shared/PageTitle";
import AccountWidget from "../../components/shared/AccountWidget";
import { Link } from "react-router-dom";
import CategoriesWidget from "../../components/shared/CategoriesWidget";
import Loading from "../../components/shared/Loading";
import { fetchOrders } from "../../store/actions/order";
import styles from "../../thema/style";
import moment from "moment";
import "moment/locale/tr";
import "../../styles/ModernOrders.css";
moment.locale("tr");

class AccountOrders extends Component {
  componentDidMount() {
    this.props.fetchOrders();
  }

  getStatusBadgeClass = (status) => {
    const statusMap = {
      Beklemede: "status-beklemede",
      Hazırlanıyor: "status-hazirlaniyor",
      Kargoda: "status-kargoda",
      "Teslim Edildi": "status-teslim-edildi",
      "İptal Edildi": "status-iptal-edildi",
      Tamamlandı: "status-teslim-edildi",
    };
    return statusMap[status] || "status-beklemede";
  };

  render() {
    if (this.props.customer.fetching) {
      return <Loading text={"Sayfa Yükleniyor..."} />;
    } else {
      if (!this.props.customer.customer) {
        return (
          <Redirect
            to={{
              pathname: "/giris-yap",
              // state: { referrer: currentLocation }
            }}
          />
        );
      }
      const orders = this.props.order.orders;
      return (
        <React.Fragment>
          <PageTitle title={"Siparişlerim"} />
          <div className="modern-orders-container">
            <div className={"container"}>
              <div className="row">
                <div className={"col-md-9"}>
                  {/* Modern Header */}
                  <div className="modern-orders-header">
                    <div className="orders-header-content">
                      <h1 className="orders-title">
                        <FontAwesomeIcon
                          icon="shopping-bag"
                          style={{ marginRight: "15px" }}
                        />
                        Siparişlerim
                      </h1>
                      <p className="orders-subtitle">
                        Tüm siparişlerinizi takip edin ve detaylarını
                        görüntüleyin
                      </p>
                      <div className="orders-breadcrumb">
                        <Link
                          to="/hesabim"
                          style={{ color: "rgba(255,255,255,0.8)" }}
                        >
                          Hesabım
                        </Link>
                        {" / "}
                        <span>Siparişlerim</span>
                        {" / "}
                        <Link
                          to="/hesabim/siparis-gecmisim"
                          style={{ color: "rgba(255,255,255,0.8)" }}
                        >
                          Sipariş Geçmişim
                        </Link>
                      </div>
                    </div>
                  </div>

                  {this.props.order.fetching ? (
                    <div className="orders-loading">
                      <div className="loading-spinner"></div>
                      <div className="loading-text">
                        Siparişler Yükleniyor...
                      </div>
                    </div>
                  ) : orders.length > 0 ? (
                    <div className="modern-orders-table">
                      {/* Table Header */}
                      <div className="orders-table-header">
                        <div className="row">
                          <div className="col-2 text-center">
                            <FontAwesomeIcon
                              icon="hashtag"
                              style={{ marginRight: "8px" }}
                            />
                            SİPARİŞ NO
                          </div>
                          <div className="col-3">
                            <FontAwesomeIcon
                              icon="info-circle"
                              style={{ marginRight: "8px" }}
                            />
                            DURUM
                          </div>
                          <div className="col-2 text-center">
                            <FontAwesomeIcon
                              icon="calendar"
                              style={{ marginRight: "8px" }}
                            />
                            TARİH
                          </div>
                          <div className="col-2 text-center">
                            <FontAwesomeIcon
                              icon="boxes"
                              style={{ marginRight: "8px" }}
                            />
                            ÜRÜN SAYISI
                          </div>
                          <div className="col-2 text-center">
                            <FontAwesomeIcon
                              icon="lira-sign"
                              style={{ marginRight: "8px" }}
                            />
                            TOPLAM
                          </div>
                          <div className="col-1 text-center">
                            <FontAwesomeIcon icon="eye" />
                          </div>
                        </div>
                      </div>

                      {/* Table Body */}
                      <div className="orders-table-body">
                        {orders.map((order, i) => (
                          <div key={i} className="order-row row">
                            <div className="col-2 text-center">
                              <div className="order-number">
                                #{order.c_number}
                              </div>
                            </div>
                            <div className="col-3">
                              <span
                                className={`order-status-badge ${this.getStatusBadgeClass(order.status)}`}
                              >
                                {order.status}
                              </span>
                            </div>
                            <div className="col-2 text-center">
                              <div className="order-date">
                                {moment(order.created_at).format("DD/MM/YYYY")}
                              </div>
                            </div>
                            <div className="col-2 text-center">
                              <span className="order-product-count">
                                {order.products.length}
                              </span>
                            </div>
                            <div className="col-2 text-center">
                              <div className="order-total">
                                ₺{parseFloat(order.total_price).toFixed(2)}
                              </div>
                            </div>
                            <div className="col-1 text-center">
                              <Link
                                className="view-order-btn"
                                to={{
                                  pathname: "/hesabim/siparis/detay",
                                  state: {
                                    id: order.id,
                                  },
                                }}
                                title="Sipariş detayını görüntüle"
                              >
                                <FontAwesomeIcon icon="eye" />
                              </Link>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  ) : (
                    <div className="orders-empty-state">
                      <div className="empty-state-icon">
                        <FontAwesomeIcon icon="shopping-cart" />
                      </div>
                      <h3 className="empty-state-title">
                        Henüz Siparişiniz Yok
                      </h3>
                      <p className="empty-state-description">
                        Henüz hiç siparişiniz bulunmamaktadır. Yeni siparişler
                        vermek için alışverişe başlayabilirsiniz.
                      </p>
                      <Link to="/" className="empty-state-action">
                        <FontAwesomeIcon icon="shopping-bag" />
                        Alışverişe Başla
                      </Link>
                    </div>
                  )}
                </div>
                <div className={"col-md-3"}>
                  <AccountWidget />
                  <CategoriesWidget />
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      );
    }
  }
}

const mapStateToProps = ({ customer, order }) => {
  return { customer, order };
};

const mapDispatchToProps = { fetchOrders };

export default connect(mapStateToProps, mapDispatchToProps)(AccountOrders);



// WEBPACK FOOTER //
// ./src/routers/Account/orders.js